import { render, staticRenderFns } from "./resourceManager.vue?vue&type=template&id=ba9d3100&"
import script from "./resourceManager.vue?vue&type=script&lang=js&"
export * from "./resourceManager.vue?vue&type=script&lang=js&"
import style0 from "./resourceManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports